import {
  createElement,
  forwardRef,
  RefAttributes,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  ComponentType,
  ComponentRef,
  ComponentProps,
} from 'react';
import { ErrorBoundary } from './error-boundary';

export function withErrorBoundary<T extends ComponentType<any>>(
  component: T,
): ForwardRefExoticComponent<PropsWithoutRef<ComponentProps<T>> & RefAttributes<ComponentRef<T>>> {
  const Wrapped = forwardRef<ComponentRef<T>, ComponentProps<T>>((props, ref) =>
    createElement(ErrorBoundary, null, createElement(component, { ...props, ref })),
  );

  // Format for display in DevTools
  const name = component.displayName || component.name || 'Unknown';
  Wrapped.displayName = `withErrorBoundary(${name})`;

  return Wrapped;
}
